import React from 'react';

import Icon from '~/core/scripts/components/Icon';
import ListSearch from '~/core/scripts/components/ListSearch';

export default props => {
  const onSearchToggle = () => props.setSearchMode(isSearch => !isSearch);

  return (
    <div className={`carcard__outer covered card-${props.index}`}>
      <div className="carcard__outer-bg">
        <div className="carcard__outer-title">
          <strong>Schätzen Sie den C0₂-Ausstoß ein</strong>, <br />
          um die Karte aufzudecken
        </div>
      </div>
      {props.isSearchMode ? (
        <div className="carcard covered search">
          <div className="carcard__inner-bg"></div>
          <div className="carcard__info-title" onClick={onSearchToggle}>
            <Icon type="down" />
            {props.Marke}
          </div>

          <hr />

          <div className="carcard__listsearch">
            <div className="carcard__listsearch-title">Andere Marke wählen</div>
            <ListSearch
              placeholder="Marke eingeben ..."
              onSelect={props.onSelect}
              data={props.options}
              searchPresetsFieldName="name"
              fieldName="name"
              searchPresets={props.shuffledOptions.slice(0, 8).map(opt => ({ name: opt.name }))}
              searchPresetsTitle="Vorschläge:"
            />
          </div>
        </div>
      ) : (
        <div className="carcard covered">
          <div className="carcard__inner-bg"></div>
          <div className="carcard__info-title">{props.Marke}</div>
          <div className="carcard__teaser">Wie viel CO₂ stoßen alle Neuzulassungen von {props.Marke} im Durchschnitt aus?</div>
          <div className="carcard__buttons">
            <button className="above" onClick={() => props.onAddBrand(props.Marke, 'above')}>
              viel
            </button>
            <button className="below" onClick={() => props.onAddBrand(props.Marke, 'below')}>
              mittel
            </button>
            <button className="belowplus" onClick={() => props.onAddBrand(props.Marke, 'below+')}>
              wenig
            </button>

            <div className="carcard__search" onClick={onSearchToggle}>
              Andere Marke wählen
              <Icon type="search" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
